import { Grid, IconButton, Typography, useMediaQuery } from "@material-ui/core";
import { FadeInDownDiv } from "components/Animations/FadeInDown";
import { BoxInfo } from "components/BoxInfo";
import Events from "components/Events";
import { DefaultInfo } from "components/NothingRight";
import { DATE_FORMAT_PRINT } from "config/constants";
import { getStatusReason } from "config/status";
import { theme } from "config/theme";
import { statusColorPrinter } from "constants/colors";
import useText from "constants/text";
import { checkParcelStatus, setParcelStatus } from "domains/CashManagement/data";
import { ToolTipInfoIcon, usePopoverStyle } from "domains/Task/components/HomeSides/ToolTipIcon";
import React from "react";
import { PersonalOrderDetail } from "domains/Task/components/PersonalOrderDetail";
import { ClientRefsAddress, Parcel, ParcelStatus } from "generated/graphql";
import { useCurrentClient } from "hooks";
import { BoxIcon, OutOfStockIcon, ParcelIcon, PriceIcon, ProductIcon, ReferenceIcon, StorageIcon } from "icons";
import moment from "moment";
import "styled-components/macro";
import StatusInfo from "ui/StatusInfo";
import { currencyFormat, formatPhoneNumber } from "utils";
import { parcelsStyles } from "./styles";



interface ParcelDetailsProps {
  parcel: Parcel;
 pickupAdress?: ClientRefsAddress
}
export function   ParcelDetails({ parcel,pickupAdress }: ParcelDetailsProps) {
  const styles = { ...parcelsStyles(), ...usePopoverStyle() };
  const smallScreen = useMediaQuery(theme.breakpoints.down("xs"));
  const { client } = useCurrentClient();
  const { text } = useText();
  const HistoryParcelStatus = {
    [ParcelStatus.AwaitingDelivery]: parcel?.parcel_attempts !== 0 ? "Reconciled" : "Received",
    [ParcelStatus.Successful]: parcel?.parcel_amount_to_collect !== 0 ? "Cash Collected" : "Reconciled",
    [ParcelStatus.Failed]: "Delivery Failure",
    [ParcelStatus.Cancelled]: "Delivery Failure",
    [ParcelStatus.MoneyToCollect]: "Reconciled",
    [ParcelStatus.ToBeAssigned]: "Dispatched",
    [ParcelStatus.Delivered]: "Delivered",
    [ParcelStatus.ToReturn]: "Reconciled",
    [ParcelStatus.ToReceive]: "Drop off created",
    [ParcelStatus.ToPick]: "Pickup Created",
    [ParcelStatus.OnDelivery]: "On Delivery",
    [ParcelStatus.NotReceived]: "Not Received",
    [ParcelStatus.NotReturned]: "Not Returned",
    [ParcelStatus.Returned]: "Returned",
    [ParcelStatus.SentBack]: "Sent Back",
    [ParcelStatus.ToHandOver]: "Assigned",
    [ParcelStatus.RToHandOver]: "Return Assigned",
    [ParcelStatus.HandedOver]: "Handed Over",
    [ParcelStatus.RHandedOver]: "Return Handed Over",
    [ParcelStatus.RToBeAssigned]: "Return Dispatched",
    [ParcelStatus.PickFailed]: "Pick Failed",
    [ParcelStatus.Picked]: "Picked",
    [ParcelStatus.OnReturn]: "On Return",
    [ParcelStatus.ToPrepare]: "To Prepare",
  };
  const orderStatus = checkParcelStatus.includes(parcel?.parcel_status)
    ? setParcelStatus[parcel?.parcel_status]
    : parcel?.parcel_status;

  return (
    <>
      {parcel ? (
        <FadeInDownDiv className={styles.rightContent}>
          <div className={styles.l1}>
            <div className={styles.divIcon}>
              {parcel.isOutOfStock ? (
                <ToolTipInfoIcon
                  placement="bottom"
                  title={
                    <div>
                      <span className={styles.ToolTipIconTitle}>{text.all.set_out_of_stock}</span>
                      <br />
                      <span className={styles.toolTipIconMessage}>{parcel.comment}</span>
                      <br />
                    </div>
                  }
                >
                  <IconButton className={styles.btnIcon}>
                    <OutOfStockIcon width={55} height={40} />
                  </IconButton>
                </ToolTipInfoIcon>
              ) : (
                <ParcelIcon width={50} height={52} />
              )}
            </div>
            <div style={{ marginLeft: 10 }}>
              <Typography className={styles.reference}>
                {text.all.parcel} {parcel?.parcel_UID}
              </Typography>
              <Typography className={styles.createdAt}>
                {text.all.created_on}{" "}
                {parcel?.parcel_created_at
                  ? moment(parcel?.parcel_created_at).format(`${DATE_FORMAT_PRINT} HH:MM`)
                  : "date..."}
              </Typography>
            </div>
            <div className={styles.status}>
              <StatusInfo
                width={smallScreen ? "71px" : "120px"}
                color={statusColorPrinter({ status: orderStatus, type: "text" })}
                background={statusColorPrinter({ status: orderStatus, type: "bg" })}
                border={statusColorPrinter({ status: orderStatus, type: "border" })}
                status={orderStatus.replace(/_/g, " ")}
              />
            </div>
          </div>
          <div className={styles.rightSubContent}>
            <div className={styles.l2}>
              <PersonalOrderDetail
              width={smallScreen ? "100%" : "98%"}
                sender={{
                  name: client?.client_contact_firstname
                    ? `${client?.client_contact_lastname} ${client?.client_contact_lastname}`
                    : `${client?.client_company_users[0]?.company_user_firstname} ${client?.client_company_users[0]?.company_user_lastname}`,
                 entrepriseClientName: client?.client_company_name,
                 entrepriseAddressName:parcel?.pickupMoreInfo?.firstName,
                 address: parcel?.pickupAddress?.address
                }}
                receiver={
                  parcel?.parcel_order?.order_receiver
                    ? {
                        name: `${parcel?.parcel_order?.order_receiver?.receiver_lastname ?? ""} ${
                          parcel?.parcel_order?.order_receiver?.receiver_firstname ?? "lastname fistname..."
                        } `,
                        number: `${
                          formatPhoneNumber(parcel?.parcel_order?.order_receiver?.receiver_phone_number) ??
                          "phone number..."
                        }`,
                        address: `${parcel?.parcel_order?.order_receiver?.receiver_address?.address ?? "address..."}`,
                        adress_details: `${
                          parcel?.parcel_order?.order_receiver?.receiver_address?.additional_address ||
                          parcel?.parcel_order?.order_receiver?.receiver_specification_address
                        }`,
                      }
                    : {
                      name: null,
                      number: null,
                      address: `${parcel?.parcel_order?.deliveryAddress?.address ?? "address..."}`,
                      adress_details: null,
                    }
                }

              />
            </div>
            <Grid className={styles.l3}>
              <div>
                <BoxInfo
                  title={text.all.description}
                  value={parcel?.parcel_description}
                  width={170}
                  icon={<ProductIcon color={theme.palette.primary.main} />}
                />
                <BoxInfo
                  width={170}
                  title={text.all.size}
                  value={parcel?.parcel_size}
                  icon={<BoxIcon color={theme.palette.primary.main} />}
                />
              </div>
              <div>
                <BoxInfo
                  width={170}
                  title={text.all.value}
                  value={currencyFormat(parcel?.parcel_value)}
                  icon={<PriceIcon color={theme.palette.primary.main} />}
                />
                <BoxInfo
                  width={170}
                  title={text.all.to_collect}
                  value={currencyFormat(parcel?.parcel_amount_to_collect)}
                  icon={<StorageIcon color={theme.palette.primary.main} />}
                />
              </div>
              <div className={styles.referenceStyle}>
                <BoxInfo
                  width={170}
                  height={70}
                  title={text.all.additionals_infos}
                  value={parcel?.parcel_additional_info}
                  icon={<ProductIcon color={theme.palette.primary.main} />}
                />
                <BoxInfo
                  width={170}
                  title={text.all.reference}
                  value={parcel?.parcel_client_reference}
                  icon={<ReferenceIcon color={theme.palette.primary.main} />}
                />
              </div>
            </Grid>
            <div className={styles.l4}>
              {parcel?.parcel_activities?.map((activity, index) => (
                <div className={styles.events}>
                  <Events
                    signature={parcel?.parcel_order?.order_validation_signature}
                    user={activity?.activity_updated_by}
                    key={index}
                    color={{
                      text: statusColorPrinter({ status: activity?.activity_trigger_action_data, type: "text" }),
                      background: statusColorPrinter({ status: activity?.activity_trigger_action_data, type: "bg" }),
                      border: statusColorPrinter({ status: activity?.activity_trigger_action_data, type: "border" }),
                    }}
                    status={HistoryParcelStatus[activity?.activity_trigger_action_data]}
                    username={activity?.activity_updated_by?.first_name || "N/A"}
                    description={
                      activity?.activity_trigger_action_data === "CANCELLED" ||
                      activity?.activity_trigger_action_data === "FAILED"
                        ? activity?.activity_trigger_action_data_reason !== null
                          ? activity?.activity_trigger_action_data_reason
                          : "N/A"
                        : getStatusReason(text, activity?.activity_trigger_action_data, client?.client_company_name)
                    }
                    timeLineColor="#d2d2d2"
                    date={moment(activity?.activity_date).format("L")}
                    time={moment(activity?.activity_date).format("LT")}
                  />
                </div>
              ))}
            </div>
          </div>
        </FadeInDownDiv>
      ) : (
        <DefaultInfo />
      )}
    </>
  );
}
